import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CodeTypeModel }             from '../core/models/code-type';
import { CompanyService }            from '../companies/company.service';
import { ConfirmService }            from '../messages/confirm/confirm.service';
import { MessagesService }           from '../messages/messages.service';
import { UserModel }                 from './typings/user';
import { UserNotificationTypeModel } from './typings/user.notification-type';
import { UsersMechanicModel }        from './typings/users.mechanic';
import { UsersService }              from './users.service';

@Component({
  selector   : 'wor-mobile-user',
  template: require('./user.mobile.component.html')
})
export class MobileUserComponent implements OnInit {
  @Input() mechanic         : UsersMechanicModel               = {} as UsersMechanicModel;
  @Input() notificationTypes: Array<UserNotificationTypeModel> = [];
  @Input() statusTypes      : Array<CodeTypeModel>             = [];
  @Input() user             : UserModel                        = {};

  selectedMechanic = {} as UsersMechanicModel;

  constructor (
    public  companyService   : CompanyService,
    private confirmService   : ConfirmService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService,
    private usersService     : UsersService
  ) {}

  ngOnInit () : void {
    this.mechanic = this.mechanic || {} as UsersMechanicModel;
    this.user     = this.user.id
      ? this.user
      : {
          mobile_dealer: this.companyService.hasDealership(),
          state        : 'ACTIVE'
        };

    this.selectedMechanic = this.mechanic.id
      ? this.mechanic
      : {
          display_name: this.user.mechanic_display_name,
          id          : this.user.mechanic_id
        } as UsersMechanicModel;

    this.user.confirm_password = this.user.password;

    if ( this.mechanic.id ) {
      this.chooseMechanic(this.mechanic);

      this.user.mobile_mechanic = true;
    }
  }

  chooseMechanic ( mechanic : UsersMechanicModel ) : void {
    if ( !mechanic || !mechanic.id ) {
      return;
    }

    this.user.first_name            = mechanic.first_name;
    this.user.last_name             = mechanic.last_name;
    this.user.mechanic_display_name = mechanic.display_name;
    this.user.mechanic_id           = mechanic.id;
  }

  delete () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_USER'))
    .then(() => this.usersService.deleteMobileUser(this.user))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.USER'), 'success');

      this.router.stateService.go('app.users');
    })
    .catch(error => this.messagesService.error(error));
  }

  formatMechanic ( mechanic : UsersMechanicModel ) : string {
    return mechanic?.display_name || '';
  }

  save ( form : NgForm ) : void {
    if ( !this.user.mobile_mechanic ) {
      delete this.user.mechanic_id;
    }

    Promise.all(this.notificationTypes.map(notification =>
      this.usersService.updateMobileNotificationType(notification, this.user.id)))
    .then(() => this.user.id
      ? this.usersService.updateMobileUser(this.user)
      : this.usersService.createMobileUser(this.user))
    .then(( user : UserModel ) => {
      form.form.markAsPristine();

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.USER'), 'success');

      this.router.stateService.go('app.mobile-user', {
        id         : user.id,
        mechanic_id: user.mechanic_id
      }, {
        reload: true
      });
    })
    .catch(error => this.messagesService.error(error));
  }

  searchMechanics = ( typed : string ) : Promise<Array<UsersMechanicModel>> => this.usersService.searchMechanics(typed);
}
